import { render, staticRenderFns } from "./PageNewVehicle.vue?vue&type=template&id=c838b74e"
import script from "./PageNewVehicle.vue?vue&type=script&lang=js"
export * from "./PageNewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports